import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { realStatus } from 'src/utils/rmasUtils';
import { setPendingValue } from './sliceFilteredRma';

const JWT_HEADERS = () => ({
  jwt: localStorage.getItem('microsoftJWT'),
  Accept: 'application/json',
  'Content-Type': 'application/json',
});

const ALL_SLICES = ['new', 'verify', 'accepted', 'shipment', 'error', 'done', 'close'];

export const prefetchRmaCounts = createAsyncThunk(
  'filteredRmas/prefetchRmaCounts',
  async (_, thunkAPI) => {
    const customerID = thunkAPI.getState().customer?.data?.id;
    if (!customerID) return thunkAPI.rejectWithValue('No customer');
    const results = await Promise.all(
      ALL_SLICES.map(async (s) => {
        try {
          const { data } = await axios.get(
            `${env.API_URL}/rmas?filters[status][$eq]=${realStatus(s)}&filters[debitor][id][$eq]=${customerID}&pagination[pageSize]=1`,
            { headers: JWT_HEADERS() }
          );
          return { slice: s, count: data?.meta?.pagination?.total ?? 0 };
        } catch {
          return { slice: s, count: 0 };
        }
      })
    );
    return results.reduce((acc, { slice, count }) => ({ ...acc, [slice]: count }), {});
  }
);

//Async Functions
export const getFilteredRma = createAsyncThunk(
  'filteredRmas/getFilteredRma',
  async (arg, thunkAPI) => {
    const state = thunkAPI.getState();
    let { idSlice, searchValueAccordion } = arg;
    const customerID = state.customer?.data?.id;
    if (!customerID) return thunkAPI.rejectWithValue('No customer loaded');
    // Manage Pending Status
    thunkAPI.dispatch(setPendingValue(idSlice));
    searchValueAccordion = searchValueAccordion !== undefined ? searchValueAccordion : '';
    const res = await axios
      .get(
        `${
          env.API_URL
        }/rmas?filters[number][$contains]=${searchValueAccordion}&filters[status][$eq]=${realStatus(
          idSlice
        )}&filters[debitor][id][$eq]=${customerID}&pagination[pageSize]=10000&sort[0]=createdAt:desc&populate=*`,
        { headers: JWT_HEADERS() }
      )
      .then((data) => {
        if (idSlice !== undefined) {
          return { filtered: idSlice, data: data.data.data };
        }
        return data.data;
      })
      .catch((err) => {
        return thunkAPI.rejectWithValue(err?.response?.data ?? err.message);
      });
    return res;
  }
);
